/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
// IMPORTS
import Moment from 'moment'
import axios from 'axios'
import { sendDatadogError } from '../../../../../services/datadog'
import { generateUUID } from './utils'
// ACTIONS

// admin dash
export const GET_DASH_DATA = 'GET_DASH_DATA'
export const DASH_DATA_LOADING = 'DASH_DATA_LOADING'
export const SET_VISIBLE = 'SET_VISIBLE'
export const RESET_DASH = 'RESET_DASH'

// messages
export const NEW_MESSAGE = 'NEW_MESSAGE'
export const EXPIRE_MESSAGE = 'EXPIRE_MESSAGE'

const dummyData = {
  team: null,
  department: null,
  company: null
}

/** **************** MESSAGES ***************** */
export function createMessage(message, expiration = 0) {
  return (dispatch, getState) => {
    const {
      type = 'generic',
      level = 'warning',
      header = '',
      content = '',
      // to reintroduce expiring messages, set the below variable confirmAction to null
      confirmAction = (messageId) => this.props.deleteMessage(messageId)
    } = message

    const id = generateUUID()

    dispatch({
      type: NEW_MESSAGE,
      data: { id, type, level, header, content, confirmAction }
    })
    if (!confirmAction && expiration) setTimeout(() => dispatch(deleteMessage(id)), expiration)
  }
}

export function deleteMessage(messageId) {
  return (dispatch, getState) => {
    dispatch({
      type: EXPIRE_MESSAGE,
      data: messageId
    })
  }
}

/** **************** ADMIN DASH ***************** */
/* Proxy URLS:
/scores/v1/
/scores/v1/departments/<department>/
/scores/v1/departments/<department>/children/
/scores/v1/teams/<manager>/
/scores/v1/teams/<manager>/children/
*/

/**
 * Pulls the large dummy teams file from the public directory once and
 * cache it to memory so subsequent requests get the local data.
 *
 *
 * @param {string} level
 * @param {*} levelId
 */
export function getDashDummyData(level = 'company', levelId = null) {
  return async (dispatch, getState) => {
    const requestOptions = {
      baseURL: window.location.origin
    }
    const levelFileName = level === 'company' ? level : `${level}s`

    const getCache = () => {
      if (dummyData[level]) {
        return Promise.resolve({ data: dummyData[level] })
      }
      return null
    }

    const request = () => axios.get(`/data/${levelFileName}.json`, requestOptions)

    const fetch = () => getCache() || request()

    dispatch({
      type: DASH_DATA_LOADING,
      data: true
    })

    return fetch()
      .then(({ data }) => {
        if (!dummyData[level]) {
          dummyData[level] = data
        }

        dispatch({
          type: GET_DASH_DATA,
          level,
          levelId,
          data: level === 'company' ? data : data[levelId]
        })
      })
      .catch((error) => sendDatadogError('Could not retrieve dummy data', 'error', error))
  }
}

export function getDashData(
  level = 'company',
  levelId = null,
  startDate = Moment().subtract(1, 'year').format('YYYYMMDD'),
  endDate = Moment().format('YYYYMMDD')
) {
  return (dispatch, getState) => {
    dispatch({
      type: RESET_DASH
    })

    const levelCache = getState().getIn(['engagement']).adminDash.getIn(['data', level])
    const token = getState().get('engagement').auth.get('JWT')

    const missingId = level !== 'company' && !levelCache.get(levelId)

    if (levelCache.size === 0 || missingId) {
      const urlLevel = level === 'company' ? '' : `${level}s/${levelId}/`
      axios({
        method: 'get',
        url: `/scores/v1/${urlLevel}?start_date=${startDate}&end_date=${endDate}`,
        headers: {
          Authorization: `${token}`
        }
      })
        .then((res) => {
          if (res.data.message)
            dispatch(
              createMessage(
                {
                  type: 'generic',
                  level: 'danger',
                  header: 'Error:',
                  content: 'Could not get company insights.'
                },
                8000
              )
            )
          else
            dispatch({
              type: GET_DASH_DATA,
              level,
              levelId,
              data: res.data
            })
        })
        .catch((err) => {
          dispatch(
            createMessage(
              {
                type: 'generic',
                level: 'danger',
                header: 'Error:',
                content: 'Could not get company insights.'
              },
              8000
            )
          )
        })
    } else {
      dispatch({
        type: SET_VISIBLE,
        level,
        levelId,
        data: level === 'company' ? levelCache : levelCache.get(levelId)
      })
    }
  }
}
